import React from "react";
import ReactApexChart from "react-apexcharts";

const CompanyNameChart = () => {
  const series = [50, 20, 70]; // Values for Empty, Mismatched, and Perfect Companies
  const options = {
    plotOptions: {
      fontFamily: "Inter",
      radialBar: {
        offsetY: 0,
        startAngle: 0,
        endAngle: 270,
        hollow: {
          margin: 5,
          size: "30%",
        },
        dataLabels: {
          name: {
            show: false,
          },
          value: {
            show: false,
          },
        },
        barLabels: {
          enabled: true,
          useSeriesColors: false,
          offsetX: -8,
          fontSize: "13px",
          color: "#999", // Set the label text color to #999
        },
      },
    },
    colors: ["#404dad", "#6e7ad4", "#efc58a"], // Updated with your specific colors
    labels: ["Empty Company", "Mismatched Company", "Perfect Company"], // Updated labels
    tooltip: {
      enabled: true,
      theme: "dark",
      style: {
        fontFamily: "Inter",
        fontSize: "13px",
        color: "#fff", // White color for tooltip text
      },
      formatter: function (val, { seriesIndex }) {
        const label = options.labels[seriesIndex];
        return `${label}: ${val}%`;
      },
    },
    responsive: [
      {
        breakpoint: 480,
        options: {
          legend: {
            show: false,
          },
        },
      },
    ],
  };

  return (
    <>
      <div className="company-chart-container">
        <ReactApexChart
          options={options}
          series={series}
          type="radialBar"
          height={260}
        />
      </div>

      <ul className='custom__legend'>
        <li className='custom__legend_EmptyCompany'>Empty Company: <span>50</span></li>
        <li className='custom__legend_PerfectC'>Perfect Company: <span>70</span></li>
        <li className='custom__legend_MismatchedC' style={{ width: '100%' }}>Mismatched Company: <span>20</span></li>
      </ul>
    </>
  );
};

export default CompanyNameChart;
